import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'
import { getCache } from 'utils/cacheService'; // Hàm để lấy cache
import { useSelector } from 'react-redux';

export const APP_NAME = 'Global Care';
export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT_URL
export const APP_PREFIX_PATH = '';
// export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards`;
// export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/apps/verhicle/orders`;
export const UNAUTHENTICATED_ENTRY = '/login'

export const THEME_CONFIG = {
	navCollapsed:false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'vi',
	navType: NAV_TYPE_SIDE,
	// topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme:'light',
	direction: DIR_LTR,
	blankLayout: false
};
